export function parsePriceAdjustment(input) {
    const text = String(input).trim();
    if (!/^[+-]?\d+(\.\d{1,2})?$/.test(text)) return null;
    const [whole, fraction = ""] = text.replace(/^[+-]/, "").split(".");
    const cents = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
    return Number.isSafeInteger(cents) ? (text.startsWith("-") ? -cents : cents) : null;
}

export function parseDurationAdjustment(input) {
    const text = String(input).trim();
    if (!/^[+-]?\d+$/.test(text)) return null;
    const minutes = Number(text);
    return Number.isSafeInteger(minutes) ? minutes : null;
}

export function validateAttributes(rows) {
    const errors = {};
    const groups = rows.map((row) => {
        const rowErrors = { options: {} };
        const name = row.name.trim();
        if (!name) rowErrors.name = "Enter an attribute name.";
        else if (Array.from(name).length > 255) rowErrors.name = "Use at most 255 characters.";
        else if (rows.some((other) => other.clientId !== row.clientId && other.name.trim().toLowerCase() === name.toLowerCase())) {
            rowErrors.name = "Use a unique attribute name.";
        }
        if (rowErrors.name) rowErrors.firstFieldId = `${row.clientId}-name`;
        if (!row.values.length) {
            rowErrors.values = "Add at least one option.";
            rowErrors.firstFieldId ||= "add-option";
        }
        const values = row.values.map((option) => {
            const optionErrors = {};
            const value = option.value.trim();
            const price = parsePriceAdjustment(option.price);
            const duration = parseDurationAdjustment(option.duration);
            if (!value) optionErrors.value = "Enter an option name.";
            else if (Array.from(value).length > 255) optionErrors.value = "Use at most 255 characters.";
            else if (row.values.some((other) => other.clientId !== option.clientId && other.value.trim().toLowerCase() === value.toLowerCase())) {
                optionErrors.value = "Use a unique option name within this attribute.";
            }
            if (price === null) optionErrors.price = "Enter a signed amount with up to 2 decimal places.";
            if (duration === null) optionErrors.duration = "Enter a signed whole number of minutes.";
            const fields = Object.keys(optionErrors);
            if (fields.length) {
                rowErrors.options[option.clientId] = optionErrors;
                rowErrors.firstFieldId ||= `${option.clientId}-${fields[0]}`;
            }
            return { ...(option.id ? { id: option.id } : {}), value, price, duration };
        });
        if (rowErrors.name || rowErrors.values || Object.keys(rowErrors.options).length) errors[row.clientId] = rowErrors;
        return { ...(row.attributeId ? { attribute_id: row.attributeId } : {}), name, required: row.required, values };
    });
    return { valid: Object.keys(errors).length === 0, errors, groups };
}

export function createAttributeDrafts(attributes) {
    return attributes.map((attribute, index) => ({
        clientId: `existing-attribute-${index}`,
        attributeId: attribute.attribute_id ?? attribute.AttributeID ?? attribute.id,
        name: String(attribute.name ?? attribute.Name ?? ""),
        required: Boolean(attribute.required ?? attribute.Required),
        values: (attribute.values ?? attribute.Values ?? []).map((option, optionIndex) => ({
            clientId: `existing-option-${index}-${optionIndex}`,
            id: option.id ?? option.ID,
            value: String(option.value ?? option.Value ?? option),
            price: (Number(option.price ?? option.Price ?? 0) / 100).toFixed(2),
            duration: String(option.duration ?? option.Duration ?? 0),
        })),
    }));
}
